// extracted by mini-css-extract-plugin
module.exports = {"hub-result-card":"hub-result-card__h81_2"};